<template>
  <div>
    <h4>{{ dashboardData.Name }}</h4>
    {{ dashboardData.Address }}
    <br />
    {{ dashboardData.PostalCode }}&nbsp;{{ dashboardData.City }}
    <br />
    <span v-if="dashboardData">
      {{ $t('Webportal.Dashboard.Brand') }}: <b-badge pill variant="primary" class="different-pill">{{ Brand }}</b-badge>
    </span> 
  </div>
</template>

<script>
export default {
  props: {
    dashboardData: Object
  },
  computed: {
    Brand() {
      return this.dashboardData.Brand || 'BMW Motorrad';
    }
  }
}
</script>

<style lang="scss" scoped>
  @use "@/../scss/bmw/cx.scss";

  .different-pill {
    color: cx.$fg-color !important;
    background-color: cx.$bg-color !important;
  }
  
</style>